// src/widgets/TableReservation/view/StepRenderer.js
import React from 'react';
import {ServiceGuestsStep} from '../sections/ServiceGuestsStep';
import {DateStep} from '../sections/DateStep';
import {TimeStep} from '../sections/TimeStep';
import {ContactStep} from '../sections/ContactStep';
import {AdditionalDetailsStep} from '../sections/AdditionalDetailsStep';
import {ConfirmationStep} from '../sections/ConfirmationStep';

export function renderStepContent({
  currentStep,
  STEPS,
  formData,
  updateFormData,
  config,
  validationErrors,
  provideValidationFunction,
  handleSetErrors,
  setIsStepReady,
  handleComplete,
  handleReset,
  handleCloseWidget,
  companyId,
  apiKey,
  displayMode,
  embedded,
}) {
  const commonProps = {
    formData,
    updateFormData,
    config,
    setValidation: provideValidationFunction,
    setErrors: handleSetErrors,
    errors: validationErrors,
    setStepReady: setIsStepReady,
  };

  switch (currentStep) {
    case STEPS.SERVICE_GUESTS:
      return <ServiceGuestsStep {...commonProps} />;

    case STEPS.DATE:
      return (
        <DateStep
          {...commonProps}
          companyId={companyId}
          apiKey={apiKey}
        />
      );

    case STEPS.TIME:
      return (
        <TimeStep
          {...commonProps}
          companyId={companyId}
          apiKey={apiKey}
        />
      );

    case STEPS.CONTACT:
      return <ContactStep {...commonProps} />;

    case STEPS.DETAILS:
      return (
        <AdditionalDetailsStep
          {...commonProps}
          companyId={companyId}
          apiKey={apiKey}
          onComplete={handleComplete}
        />
      );

    case STEPS.CONFIRMATION:
      return (
        <ConfirmationStep
          formData={formData}
          config={config}
          onReset={handleReset}
          onClose={displayMode === 'floating' || embedded ? handleCloseWidget : null}
        />
      );

    default:
      return null;
  }
}
